export default {
	section_main_banner: {
		title: {
			one: 'Empower',
			two: 'Your',
			three: 'Transactions',
			four: 'with',
			five: 'Cryptographic',
			six: 'Assets',
		},
		description: {
			one: 'With our platform, payments can be made instantly and seamlessly,',
			two: 'without the need to exchange your cryptographic assets-ensuring speed,',
			three: 'security & convenience.',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},
	section_safety_speed: {
		cards: {
			secure_payment: {
				title: 'Secure Payment',
				description:
					'JPWorldPay does not disclose your information during QR code transactions.',
			},
			any_company: {
				title: 'Any Company',
				description:
					'Pay instantly and securely at offline merchants anywhere, 24 hours a day.',
			},
			touch_free: {
				title: 'Touch Free',
				description:
					"Don't worry about cash or credit card- open the application and pay.",
			},
		},
		fastest_payment: {
			label: 'Fastest Payment System',
			title: {
				one: "JPWorldPay's",
				two: 'Safety',
				three: ' &',
				four: 'Speed',
				five: 'At Same Time',
			},
			description:
				"Experience the fastest and most reliable payment system, combining the proven stability of blockchain technology with the innovation of JPWorldPay's unique platform delivering speed, security & seamless transactions like never before.",
		},
		registration: {
			title: 'Free Registration',
			description:
				'You only need an email address and some basic information about your business.',
		},
		start_payment: {
			title: 'Start Payment',
			description:
				'Once you confirm your email, company name & link your account, your sales prep is complete.',
		},
		cta_button: 'Starting to sign up',
	},
	section_we_offer: {
		title: {
			one: 'Enjoy Shopping Anywhere',
			two: 'We Offer It For',
			three: 'Free',
		},
		description:
			'JPWorldPay offers the best technology, the best service, and the best platform - all completely free. Experience premium features without the premium price. Start growing your business with zero upfront cost. Join the future of seamless and secure payments today.',
		enjoy_shopping: {
			title: 'Enjoy Shopping Anywhere',
			description: 'With cryptocurrency stored in your JPWorldPay wallet',
			boxes: {
				one: {
					title: 'Ideal Crypto Wallet',
					description: {
						one: 'Make a cryptocurrency wallet that you',
						two: 'want in JPWorldPay.',
					},
				},
				two: {
					title: 'Shop Smarter',
					description: {
						one: 'Please choose JPWorldPay when you are',
						two: 'shopping.',
					},
				},
				three: {
					title: 'Pay With Us',
					description: {
						one: 'Pay with the cryptocurrency you want',
						two: 'on JPWorldPay.',
					},
				},
			},
			cta_button: 'Create A Free Account',
		},
	},
	section_payment_free: {
		desktop: {
			label: 'Fastest Payment System',
			title: {
				one: 'It Can Be Used',
				two: 'Anywhere',
				three: 'In The World',
			},
			descriptionFirst:
				"JPWorldPay offers a seamless and flexible payment experience without the need for a credit card. Whether you're shopping online or in-store, all you need is a Wi-Fi connection to make instant payments using a simple QR code.",
			descriptionSecond:
				'JPWorldPay also supports offline payments through kiosks and POS machines, letting you complete transactions anytime, anywhere — no cards, no hassle, just fast, secure payments.',
			cta_button: 'Getting Started For Free',
		},
		mobile: {
			label: 'Enjoy Shopping Anywhere',
			title: {
				one: 'Free',
				two: 'for Business Members ',
			},
			description:
				'One Tether works without a credit card. Just connect to wi-fi to pay instantly via QR code-Even offline through kiosks and pos Machine.',
			cta_button: 'Opening A Business Store',
		},
	},
	section_business_anywhere: {
		label: 'Enjoy Shopping Anywhere',
		title: {
			one: 'Free',
			two: 'for Business Members',
		},
		description:
			'One Tether works without a credit card. Just connect to wi-fi to pay instantly via QR code-Even offline through kiosks and pos Machine.',
		cta_button: 'Opening A Business Store',
		advantage: {
			label: 'Fastest Payment System',
			title: {
				one: 'With',
				two: 'JPWorldPay',
				three: 'There',
				four: 'Are So Many',
				five: 'Advantages',
			},
			description:
				'JPWorldPay works without a credit card. Just connect to Wi-Fi to pay instantly via QR code — even offline through kiosks and POS machines.',
			payment_methods: {
				qr_code: {
					title: 'QR Code Payment',
					description: 'Easy Payment With QR Code',
				},
				onetether: {
					title: 'JPWorldPay Payment',
					description: 'Pay Anywhere',
				},
				kiosk: {
					title: 'Kiosk & POS Machine',
					description: 'Convenient Offline Payment',
				},
			},
			cta_button: 'How To Shop & Pay',
		},
	},
	section_question: {
		label: 'Question & Answer',
		title: {
			one: 'We Hear Your',
			two: 'Voice',
		},
		description:
			'At JPWorldPay, we value your feedback and turn it into action. By listening and improving based on real user input, we ensure our services stay relevant, user-friendly, and built around your needs.',
		cta_button: 'Get Started With Q&A',
	},
	section_growth: {
		stats: {
			total_customers: {
				value: '800k',
				label: 'Total Customers',
			},
			customer_satisfaction: {
				value: '99.90%',
				label: 'Customers Satisfaction',
			},
			money_managed: {
				value: '260b',
				label: 'Money Managed',
			},
		},
	},
	section_testimonials: {
		subtitle: 'What our client say about JPWorldPay',
		title: {
			one: 'More Than 1,405,28',
			two: 'Happy Customers',
			three: 'Trust',
			four: 'Our Services',
		},
		testimonial_card: {
			description:
				'JPWorldPay is the best payment platform I have ever used. It is very easy to use and the customer service is excellent.',
			author: {
				name: 'John Doe',
				role: 'CEO, JPWorldPay',
			},
		},
	},
	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
